import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

class CasesScroller {
    constructor(element) {
        this.element = element;
    }
    mount() {
        const cases = this.element.querySelectorAll('[data-case]');
        const heading = this.element.querySelector('[data-heading]');

        if (!cases || cases.length === 0)
            return;

        const lastCaseShadow = cases[cases.length - 1].querySelector('[data-shadow]');

        const tl = gsap.timeline({ defaults: { ease: 'power1.inOut' } }).to(heading, {
            scrollTrigger: {
                trigger: cases[0],
                endTrigger: cases[cases.length - 1],
                start: 'center center',
                end: `center center`,
                pin: heading,
                pinSpacing: false,
                scrub: 1,
            },
        });

        cases.forEach((item, index) => {
            tl.to(item, {
                scrollTrigger: {
                    trigger: item,
                    endTrigger: cases[cases.length - 1],
                    start: 'center center',
                    end: `center center`,
                    pin: item,
                    pinSpacing: false,
                    // markers: true,
                    scrub: 1,
                },
            });

            if (index < cases.length - 1) {
                tl.to(item, {
                    scrollTrigger: {
                        trigger: item,
                        endTrigger: item,
                        start: 'center center',
                        scrub: 1,
                    },
                    scale: 0.8,
                });
            }

            if (index === cases.length - 1) {
                tl.to(item, {
                    scrollTrigger: {
                        trigger: item,
                        endTrigger: item,
                        start: 'bottom 95%',
                        end: `center center`,
                        scrub: 1,
                    },
                });
                tl.fromTo(
                    lastCaseShadow,
                    { opacity: 0 },
                    {
                        scrollTrigger: {
                            trigger: item,
                            endTrigger: item,
                            start: 'bottom 95%',
                            end: `center center`,
                            scrub: 1,
                        },
                        opacity: 1,
                    }
                );
            }
        });
    }
}

document.querySelectorAll('[g-component="CasesScroller"]').forEach(item => {
    new CasesScroller(item).mount();
});